/* eslint-disable object-curly-newline */
import attributeApi from '@/api/attribute';
import blogApi from '@/api/blog';
import blogTypeApi from '@/api/blog-type';
// import countryApi from '@/api/country';
// import regionApi from '@/api/region';
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  fetchBlogs({ commit }, { filters, errorManagementType }) {
    return blogApi.fetchBlogs(filters, errorManagementType)
      .then(storeActionCommit(commit, 'setBlogs'));
  },

  fetchBlog({ commit }, { id, idType, errorManagementType }) {
    idType = idType == null ? 'id' : idType;

    return blogApi.fetchBlog(id, idType, errorManagementType)
      .then(storeActionCommit(commit, 'setBlog'));
  },

  fetchBlogFilters({ commit }, { errorManagementType }) {
    return Promise.all([
      blogTypeApi.fetchBlogTypes(errorManagementType),
      attributeApi.fetchAttributes('BLOG_THEME', errorManagementType),
      // countryApi.fetchCountries('blogs', errorManagementType),
      // regionApi.fetchRegions(errorManagementType),
    ]).then((result) => {
      commit('setFilters', {
        types: result[0],
        themes: result[1],
        // countries: result[2],
        // regions: result[3],
        // authors: result[4],
      });
    });
  },
};
